import { filterObjectByFields, queryBuilder } from './../utils/functions'
import downloadService from './file.download.service'
import BaseService from './base.service'

class RecruitmentService extends BaseService {
  async getRecruitments(
    pageNum,
    pageSize,
    sortBy,
    sortOrder,
    filters,
    startDate,
    endDate,
    searchString
  ) {
    const query = queryBuilder(
      pageNum,
      pageSize,
      sortBy,
      sortOrder,
      filters,
      startDate,
      endDate,
      searchString
    )

    console.log('Query: ', query)

    const res = await fetch(`/api/v1/recruitments?${query}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'same-origin',
    })

    this.handleHttpErrors(res)

    const recruitments = await res.json()
    return recruitments
  }

  async getCount() {
    try {
      const res = await fetch('/api/v1/recruitments/count', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
      })

      this.handleHttpErrors(res)

      const count = await res.json()
      return count
    } catch (err) {
      console.error('Error: ', err)
    }
  }

  async createRecruitment(data) {
    console.log('Data', data)

    const recruitmentObj = this.mapCheckboxValues(data)

    console.log('Mapped Data', recruitmentObj)

    try {
      const res = await fetch('/api/v1/recruitments', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(recruitmentObj),
        credentials: 'same-origin',
      })
      this.handleHttpErrors(res)
      const json = await res.json()
      console.log('Success: ', JSON.stringify(json))
    } catch (err) {
      console.error('Error: ', err)
    }
  }

  async updateRecruitment(id, data) {
    console.log('Data', data)

    const recruitmentObj = this.mapCheckboxValues(data)
    recruitmentObj['AxiomStatus'] = 'submitted'

    console.log('Mapped Data', recruitmentObj)

    try {
      const res = await fetch(`/api/v1/recruitments/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(recruitmentObj),
        credentials: 'same-origin',
      })
      this.handleHttpErrors(res)
      const json = await res.json()
      console.log('Success: ', JSON.stringify(json))
    } catch (err) {
      console.error('Error: ', err)
    }
  }

  async uploadRecruitmentFile(options, recruitId, fileType) {
    console.log('OPTIONS', options)

    const formData = new FormData()

    formData.set('files', options.file, options.file.name)
    formData.set('recruitId', recruitId)
    formData.set('fileType', fileType)

    try {
      const res = await fetch('/api/v1/recruitments/upload', {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
      })
      this.handleHttpErrors(res)
      const json = await res.json()
      options.onSuccess(json.data, options.file)
      console.log('Success: ', JSON.stringify(json))

      if (json.rspCode === 'ok') {
        return json.files[0]
      } else {
        return
      }
    } catch (err) {
      console.error('Error: ', err)
      options.onError(err)
    }
  }

  async downloadRecruitmentFiles(arrayOfStringIds) {
    console.log('Array of String Ids', arrayOfStringIds)

    try {
      downloadService.download(
        '/api/v2/recruitments/download',
        'recruitments.zip',
        {
          method: 'POST',
          body: JSON.stringify(arrayOfStringIds),
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
    } catch (err) {
      console.error('Error: ', err)
    }
  }

  async getPositions() {
    try {
      const res = await fetch('/api/v1/positions', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
      })
      const positions = await res.json()
      return positions
    } catch (err) {
      console.error('Error: ', err)
    }
  }

  async createPosition(position) {
    try {
      const res = await fetch('/api/v1/positions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ name: position }),
        credentials: 'same-origin',
      })
      const json = await res.json()
      console.log('Success: ', JSON.stringify(json))
      return json
    } catch (err) {
      console.error('Error: ', err)
    }
  }

  async deletePosition(id) {
    try {
      const res = await fetch(`/api/v1/positions/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
      })
      const json = await res.json()
      console.log('Success: ', JSON.stringify(json))
      return json
    } catch (err) {
      console.error('Error: ', err)
    }
  }

  getProfileContactData(recruitmentData) {
    const fields = [
      'name',
      'nationality',
      'qualification',
      'countryofexperience',
      'yearsofexperience',
      'phone',
      'email',
      'location',
    ]

    const filteredObject = filterObjectByFields(fields, recruitmentData)
    return filteredObject
  }

  getMainExperiencePositionData(recruitmentData) {
    const fields = [
      'checkboxNGOs',
      'checkboxUNs',
      'checkboxDonors',
      'checkboxConsultancyGroup',
      'NGOs',
      'UNs',
      'donors',
      'consultant',
      'agency',
      'position',
      'English',
      'Swahili',
      'Arabic',
      'Portuguese',
      'French',
      'Spanish',
      'Somali',
      'otherlang',
    ]

    const filteredObject = filterObjectByFields(fields, recruitmentData)
    return filteredObject
  }

  getCandidateExperienceDetailsData(recruitmentData) {
    const fields = [
      'assessment',
      'Proposal',
      'Program',
      'baseline',
      'MidEval',
      'FinEval',
      'research',
      'Training',
      'Monitoring',
      'ThirdPartyMonitoring',
      'Survey',
      'ImpactAssessment',
      'Flood',
      'Drought',
      'Tsunami',
      'Displaced',
      'Conflict',
      'Epidemic',
      'development',
      'othercrisis',
      'ClientNGO',
      'EU',
      'DFID',
      'USAID',
      'DANIDA',
      'SIDA',
      'CIDA',
      'NORAD',
      'AusAID',
      'JICA',
      'UNDP',
      'WFP',
      'WB',
      'HCR',
      'UNICEF',
      'OtherUNAgencies',
      'UNHABITAT',
      'otherClients',
      'ME',
      'WaterandSanitation',
      'Protection',
      'Livelihood',
      'GIS',
      'Finance',
      'Logistic',
      'HumanRight',
      'Advocacy',
      'HIV',
      'Gender',
      'environment',
      'Health',
      'Agriculture',
      'Nutrition',
      'Governance',
      'Poverty',
      'Administration',
      'Education',
      'Business',
      'Distribution',
      'Livestock',
      'Stabilization',
      'Resilience',
      'Security',
      'DataManagement',
      'Sampling',
    ]

    const filteredObject = filterObjectByFields(fields, recruitmentData)
    return filteredObject
  }

  getSupportingDocumentsData(recruitmentData) {
    const fields = ['_id', 'fileCV', 'fileCL', 'fileRI']

    const filteredObject = filterObjectByFields(fields, recruitmentData)
    return filteredObject
  }

  mapCheckboxValues(data) {
    let recruitmentObj = {}

    for (let [key, value] of Object.entries(data)) {
      if (value === true) {
        value = 'OK'
      }

      if (value === false) {
        value = ''
      }

      recruitmentObj[key] = value
    }

    return recruitmentObj
  }
}

const recruitmentService = new RecruitmentService()

export default recruitmentService
